// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wWRl","tabsBox":"styles_tabsBox__1nrOu","createButton":"styles_createButton__1Httq"};